module.exports = __webpack_public_path__ + "img/regulations-leisure-1.cbf439b3.jpg";